import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-bulk-supplier',
  templateUrl: './payments-bulk-supplier.component.html',
  styleUrls: ['./payments-bulk-supplier.component.css']
})
export class PaymentsBulkSupplierComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
